// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"841":"320069c256da9300ff13","2575":"bde1c22c29e160cdb3f1","7587":"320069c256da9300ff13","7676":"320069c256da9300ff13","8736":"318aba71beb7ba15a1f0"}[chunkId] + ".css";
};